<div class="select-custom-workflow">
  <p-dropdown
    [options]="$templates()"
    [loading]="loadingTemplates()"
    [(ngModel)]="workflowSelectedOption"
    optionLabel="name"
    placeholder="Validation circuits option"
    class="dropdown-width"
  />
  <span>
    Obtain the 'Verified' label after getting approved.
  </span>
  <p-button
    label="Start verification"
    [disabled]="!workflowSelectedOption"
    (onClick)="startWorkflow(workflowSelectedOption!.id)"
  />
</div>
